module.exports = __webpack_public_path__ + "static/media/logo_white.5948bf67.png";